export default __webpack_public_path__ + "static/media/intro4.70cb615e.mp3";